
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import { Component, ActionButtonConfig, FormModalMixins, menuRouteHelper, systemConst,Prop,appConst} from "@/lib";


@Component
export default class CreateCheckPointSetting extends FormModalMixins  {
  model =new DeclareCustoms();
  loading:boolean = false;
  created(){
      Object.assign(this.config, {modelTitleL: "app.DeclareCustoms.InfoDownLoad",labelWidth:100,width:500,isHideOk:true });
      this.model.isofficialSeal=appConst.yesorNo.yes;
  }



  async download(){
    if(this.model.formType=='3'||this.model.formType=='5')
  await this.$store.dispatch({type:"shipment/declarecustoms/checkdownloadDeclareProduct", id:this.model.id });
   if(this.model.formType=='4'||this.model.formType=='5')
  await this.$store.dispatch({type:"shipment/declarecustoms/checkdownloadElement", id:this.model.id });
   try {
    this.loading = true;
    let response = await this.$store.dispatch({
      type: "shipment/declarecustoms/exportAllForm",
      data: { id: this.model.id ,formType:this.model.formType,officialSeal:this.model.isofficialSeal}
    });
    this.loading = false;
    let name = response.headers["content-disposition"].split("=")[1];
    this.$util.downloadFile(response.data, decodeURI(name));
    this.close()
     } catch (error) {

    }finally{ this.loading = false;}
  }
selectalldio(value){}
  
    get infoList() {
        
        return [
            {value: "1", displayText: "发票单"},
            {value: "2", displayText: "装箱单"},
            {value: "3", displayText: "报关单"},
            {value: "4", displayText: "申报要素"},   
           {value: "5", displayText: "所有表单"}, 
        ]
    }

      get YNList() {
           return this.getCodeListByCategory(
      appConst.codeCategory.yesOrNo)
    }
      get record(){       
      var tt=this.$store.state.shipment.declarecustoms.editDeclareCustoms;
       tt.isofficialSeal=appConst.yesorNo.yes;
      return tt
    };
}
